<template>
    <div>
        <v-container fluid pt-3 grid-list-xl>
            <app-card customClasses="mb-30 inherit-overflow">
                <div>
                    <h3>Events</h3>
                </div>
                <v-data-table v-bind:headers="headers" :items="guestDetailEvents" :items-per-page="10">
                    <template slot="items" slot-scope="props">
                        <td @click="showEvent(props.item._id)">{{ props.item.dateFrom }}</td>
                        <td @click="showEvent(props.item._id)">{{ props.item.dateTo }}</td>
                        <td @click="showEvent(props.item._id)">{{ props.item.eventName }}</td>
                    </template>
                </v-data-table>
            </app-card>
        </v-container>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'guestDetailEvents',
            'user',
            'season'
        ]),
    },
    data() {
        return {
            headers: [
                {
                    text: 'Date From',
                    value: "dateFrom",
                    align: 'left',
                },
                {
                    text: 'Date To',
                    value: "dateTo",
                    align: 'left',
                },
                {
                    text: 'Event',
                    value: "eventName",
                    align: 'left',
                }
            ],
        }
    },
    methods: {
        showEvent(id) {
            this.$router.push({
                name: 'waitinglist.requests',
                params: {
                    eventId: id
                }
            });
        }
    },
    created() {
        this.$store.dispatch('getGuestDetailsEvents', { companyId: this.user.company.id, seasonId: this.season });
    }
}
</script>